import Tenant from "@shared/lib/Http";

const state = {
    activeSession: false,
    userActive: false,
    adminToken: null,
    tenantToken: null,
    idle: false,
    saved: true,
    hasControl: false,
    teams: [],
    referrers: []
}

const getters = {
    activeSession: (state) => state.activeSession,
    getUserActive: (state) => state.userActive,
    adminToken: (state) => state.adminToken,
    tenantToken: (state) => state.tenantToken,
    idle: (state) => state.idle,
    saved: (state) => state.saved,
    hasControl: (state) => state.hasControl,
    // ====================================
    // Teams
    // ====================================
    getTeams: (state) => {
        return state.teams
    },
    // ====================================
    // Referrers
    // ====================================
    getReferrers: (state) => {
        return state.referrers
    },
}

const mutations = {
    setActiveSession(state, status) {
        state.activeSession = status
        if (!status) {
            window.location.reload(true)
        }
    },
    setUserActive(state, status) {
        state.userActive = status
        if (status == true) {
            return new Promise((resolve, reject) => {
                axios.post("/heartbeat/reset").then(
                    (response) => {
                        state.userActive = status
                        resolve(response)
                    },
                    (error) => {
                        reject(error)
                    }
                )
            })
        }
    },
    setAdminToken(state, token) {
        state.adminToken = token
    },
    setTenantToken(state, token) {
        state.tenantToken = token
    },
    setIdle(state, status) {
        state.idle = status
    },
    setSaved(state, status) {
        state.saved = status
    },
    setHasControl(state, status) {
        state.hasControl = status
    },
    // ====================================
    // Teams
    // ====================================
    setTeams(state, data) {
        state.teams = data
    },
    // ====================================
    // Referrers
    // ====================================
    setReferrers(state, data) {
        state.referrers = data
    },
}

const actions = {
    setActiveSession(context, status) {
        context.commit("setActiveSession", status)
    },
    setUserActive(context, status) {
        context.commit("setUserActive", status)
    },
    setAdminToken(context, token) {
        context.commit("setAdminToken", token)
    },
    setTenantToken(context, token) {
        context.commit("setTenantToken", token)
    },
    setIdle(context, status) {
        context.commit("setIdle", status)
    },
    setSaved(context, status) {
        context.commit("setSaved", status)
    },
    setHasControl(context, status) {
        context.commit("setHasControl", status)
    },

    // ====================================
    // Teams
    // ====================================
    setTeams({ dispatch, commit, state }, data) {
        return new Promise((resolve, reject) => {
            Tenant.post("/api/application-audit/get-teams", data).then(
                (response) => {
                    commit("setTeams", response.data)
                    resolve(response)
                },
                (error) => {
                    reject(error)
                }
            )
        })
    },
    // ====================================
    // Referrers
    // ====================================
    setReferrers({ dispatch, commit, state }, data) {
        return new Promise((resolve, reject) => {
            Tenant.get("/api/referrers/list", data).then(
                (response) => {
                    commit("setReferrers", response.data)
                    resolve(response)
                },
                (error) => {
                    reject(error)
                }
            )
        })
    },
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
}
